import React, { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import { Block } from "kanopi-components/Block";
import { Check } from "baseui/icon";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TCybersourceField = {
  id: string;
  fieldRef: unknown;
  valid: boolean;
  setValid: Dispatch<SetStateAction<boolean>>;
};
export const CybersourceField: FC<TCybersourceField> = ({
  valid,
  setValid,
  id,
  fieldRef,
}: TCybersourceField) => {
  const [, theme] = useStyletron();
  const [keyOut, setKeyOut] = useState<boolean>();
  const [borderBottomColor, setBorderBottomColor] = useState(theme.colors.mono400);
  fieldRef &&
    fieldRef.on("change", (data) => {
      setValid(data.valid);
    });
  fieldRef &&
    fieldRef.on("focus", () => {
      setKeyOut(false);
    });
  fieldRef &&
    fieldRef.on("blur", () => {
      setKeyOut(true);
    });

  useEffect(() => {
    if (valid) {
      setBorderBottomColor(theme.colors.borderPositive);
    } else if (valid === false) {
      setBorderBottomColor(theme.colors.borderNegative);
    }
  }, [valid]);
  return (
    <Block position="relative">
      {valid && keyOut && (
        <Block display="inline" position="absolute" right="0" bottom="0">
          <Check size={24} color={theme.colors.inputBorderPositive} />
        </Block>
      )}
      <div
        id={id}
        style={{
          height: theme.sizing.scale800,
          paddingBottom: theme.sizing.scale400,
          borderBottomColor: borderBottomColor,
        }}
      ></div>
    </Block>
  );
};
